import { Box, Button } from "@mui/material";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useMemo } from "react";
import { useScheduleUIContext } from "../ScheduleUIContext";

// HOOKS
import useAuth from "app/hooks/useAuth";

export function ScheduleToolbar() {
  const { isStrictAccess } = useAuth();
  const scheduleUIContext = useScheduleUIContext();
  const scheduleUIProps = useMemo(() => {
    return {
      goToAddQuotaSchedule: scheduleUIContext.goToAddQuotaSchedule,
    };
  }, [scheduleUIContext]);
  const { goToAddQuotaSchedule } = scheduleUIProps;

  return (
    <Box>
      <Box
        className="position-tambah-jadwal"
        sx={{
          alignItems: "center",
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          m: -1,
        }}
      >
        <h1 className="pages-title">
          <u>Dashboard Pilih Jadwal Penyedotan</u>
        </h1>
        {isStrictAccess && (
          <Box sx={{ m: 1 }}>
            <Button
              color="primary"
              variant="contained"
              onClick={goToAddQuotaSchedule}
              startIcon={<AddCircleOutlineIcon />}
              title="Tambah Kuota Jadwal Penyedotan"
            >
              Tambah Kuota
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
}
